<template>
    <div v-if="isFile(currentFile) && !isFolder(currentFile)">
        <template v-if="isImage(currentFile)">
            <img
                v-if="imageData"
                :src="imageData"
                class="img-responsive text-center d-block mx-auto"
            />
            <v-progress-circular
                v-else
                indeterminate
                color="primary"
                class="text-center d-block mx-auto"
            ></v-progress-circular>
        </template>
        <div v-else class="text-center">
            <i class="icon-file-text2"></i>
        </div>
        <div class="my-3">
            <p>
                Nume: <b>{{ currentFile.name }}</b><br/>
                Dimensiune: <b>{{ currentFile.size | humanFileSize }}</b><br/>
                Incarcat in data de: <b>{{ currentFile.modified | formatDate('DD/MM/YYYY HH:mm:ss A') }}</b>
            </p>
            <v-btn color="primary" @click="downloadCurrentFile">Descarcare</v-btn>
        </div>
    </div>
</template>

<style scoped>
    .icon-file-text2 {
        font-size: 15rem;
    }

    #media-manager-preview-image {
        max-height: 200px;
    }
</style>

<script>
    import PreviewSideBar from "../../../../packages/media-manager/js/components/subcomponents/PreviewSideBar";

    export default {
        extends: PreviewSideBar,
        props: {
            prefix: {
                type: String,
                required: true
            }
        },
        data() {
            return {
                imageData: undefined
            }
        },
        async mounted() {
            if (this.isFile(this.currentFile) && !this.isFolder(this.currentFile)) {
                if (this.isImage(this.currentFile)) {
                    this.imageData = await this.streamCurrentFile()
                } else {
                    this.imageData = undefined
                }
            }
        },
        methods: {
            downloadCurrentFile() {
                return this.downloadFile(`${this.prefix}download?path=${this.currentFile.fullPath}`)
                    .catch((e) => {
                        this.showError(e.toString())
                    })
            },
            streamCurrentFile() {
                return this.streamFile(`${this.prefix}response?path=${this.currentFile.fullPath}`)
                    .then((response) => {
                        return response
                    })
                    .catch((e) => {
                        this.showError(e.toString())
                    })
            }
        }
    };
</script>
